exports.init = function () {
    app.components.initComponent('GenerateBarcode');
};
